import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { Button, Icon, message, Modal } from "antd";
import LoadMore from "components/LoadMore";
import {
    clearAll,
    getMessageList,
    getMessageScope,
    NoticeListItem
} from "service/notice";
import { errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";
import ListItem from "../components/ListItem";
import useRequest from "utils/useRequest";
import CreateNotice from "../components/CreateNotice";
import ReadModal from "../components/ReadModal";
import Empty from "../components/Empty";

export default function PageSend() {
    const PageSize = 20;
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false); // 是否还有下一页
    const [currentId, setCurrentId] = useState(0); // 当前展开的
    const [currentReadId, setCurrentReadId] = useState(0); // 当前弹出已读未读列表的id

    const [showCreate, setShowCreate] = useState(false);
    const [list, setList] = useState<NoticeListItem[]>([]);

    const [treeData] = useRequest(getMessageScope);

    useEffect(() => {
        loadData(page, PageSize).catch(e => message.error(errorMessage(e)));
    }, []);

    // 加载更多
    const loadMore = usePromiseCallback(async () => {
        const newPage = page + 1;

        return loadData(newPage, PageSize, false)
            .then(() => {
                setPage(newPage);
            })
            .catch(e => {
                message.error(errorMessage(e));
            });
    });

    // 加载数据
    function loadData(pageNo: number, pageSize: number, clear: boolean = true) {
        return getMessageList(pageNo, pageSize).then(data => {
            setList(clear ? data.model1List : [...list, ...data.model1List]);
            setHasMore(data.count / PageSize > pageNo);
        });
    }

    async function handleCreate() {
        return getMessageList(1, 1)
            .then(data => {
                setList([...data.model1List, ...list]);
            })
            .catch(e => {
                message.error(errorMessage(e));
            });
    }

    function handlerClear() {
        Modal.confirm({
            title: "提醒",
            content: "确认要清空全部通知吗?",
            onOk: async () => {
                try {
                    await clearAll();
                    message.success("已清空!");
                    await loadData(1, 20);
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    return (
        <div className={style.root}>
            {list.length !== 0 && (
                <div className={style.tools}>
                    <Button
                        className={style.button}
                        type="primary"
                        ghost
                        onClick={handlerClear}>
                        清空全部
                    </Button>
                    <Button
                        className={style.button}
                        type="primary"
                        onClick={() => setShowCreate(true)}>
                        <Icon type="plus" /> 创建通知
                    </Button>
                </div>
            )}
            <div className={style.body}>
                {list.map(item => (
                    <ListItem
                        key={item.id}
                        data={item}
                        onClick={() =>
                            setCurrentId(item.id === currentId ? 0 : item.id)
                        }
                        onShowReadCount={() => setCurrentReadId(item.id)}
                        active={currentId === item.id}
                    />
                ))}

                <LoadMore onVisible={loadMore} hasMore={hasMore} />

                {list.length === 0 && (
                    <Empty onClick={() => setShowCreate(true)} />
                )}
            </div>

            <CreateNotice
                visible={showCreate}
                treeData={treeData || []}
                onClose={() => setShowCreate(false)}
                onSuccess={handleCreate}
            />
            <ReadModal id={currentReadId} onClose={() => setCurrentReadId(0)} />
        </div>
    );
}
